import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useSnackbar } from "notistack";
import * as React from "react";
import SanitizeTextboxInput from "./SanitizeTextboxInput";

const ConfigSEO = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  // const [selectedLang, setSelectedLang] = React.useState(props.primaryLanguage);
  // const [selectedLang, setSelectedLang] = React.useState("en-English");
  const languages = [
    { lang: "ab-Abkhazian", langName: "ab-Abkhazian" },
    { lang: "aa-Afar", langName: "aa-Afar" },
    { lang: "af-Afrikaans", langName: "af-Afrikaans" },
    { lang: "ak-Akan", langName: "ak-Akan" },
    { lang: "sq-Albanian", langName: "sq-Albanian" },
    { lang: "am-Amharic", langName: "am-Amharic" },
    { lang: "ar-Arabic", langName: "ar-Arabic" },
    { lang: "an-Aragonese", langName: "an-Aragonese" },
    { lang: "hy-Armenian", langName: "hy-Armenian" },
    { lang: "as-Assamese", langName: "as-Assamese" },
    { lang: "av-Avaric", langName: "av-Avaric" },
    { lang: "ae-Avestan", langName: "ae-Avestan" },
    { lang: "ay-Aymara", langName: "ay-Aymara" },
    { lang: "az-Azerbaijani", langName: "az-Azerbaijani" },
    { lang: "bm-Bambara", langName: "bm-Bambara" },
    { lang: "ba-Bashkir", langName: "ba-Bashkir" },
    { lang: "eu-Basque", langName: "eu-Basque" },
    { lang: "be-Belarusian", langName: "be-Belarusian" },
    { lang: "bn-Bengali (Bangla)", langName: "bn-Bengali (Bangla)" },
    { lang: "bh-Bihari", langName: "bh-Bihari" },
    { lang: "bi-Bislama", langName: "bi-Bislama" },
    { lang: "bs-Bosnian", langName: "bs-Bosnian" },
    { lang: "br-Breton", langName: "br-Breton" },
    { lang: "bg-Bulgarian", langName: "bg-Bulgarian" },
    { lang: "my-Burmese", langName: "my-Burmese" },
    { lang: "ca-Catalan", langName: "ca-Catalan" },
    { lang: "ch-Chamorro", langName: "ch-Chamorro" },
    { lang: "ce-Chechen", langName: "ce-Chechen" },
    {
      lang: "ny-Chichewa, Chewa, Nyanja",
      langName: "ny-Chichewa, Chewa, Nyanja",
    },
    { lang: "zh-Chinese", langName: "zh-Chinese" },
    {
      lang: "zh-Hans-Chinese (Simplified)",
      langName: "zh-Hans-Chinese (Simplified)",
    },
    {
      lang: "zh-Hant-Chinese (Traditional)",
      langName: "zh-Hant-Chinese (Traditional)",
    },
    { lang: "cv-Chuvash", langName: "cv-Chuvash" },
    { lang: "kw-Cornish", langName: "kw-Cornish" },
    { lang: "co-Corsican", langName: "co-Corsican" },
    { lang: "cr-Cree", langName: "cr-Cree" },
    { lang: "hr-Croatian", langName: "hr-Croatian" },
    { lang: "cs-Czech", langName: "cs-Czech" },
    { lang: "da-Danish", langName: "da-Danish" },
    {
      lang: "dv-Divehi, Dhivehi, Maldivian",
      langName: "dv-Divehi, Dhivehi, Maldivian",
    },
    { lang: "nl-Dutch", langName: "nl-Dutch" },
    { lang: "dz-Dzongkha", langName: "dz-Dzongkha" },
    { lang: "en-English", langName: "en-English" },
    { lang: "eo-Esperanto", langName: "eo-Esperanto" },
    { lang: "et-Estonian", langName: "et-Estonian" },
    { lang: "ee-Ewe", langName: "ee-Ewe" },
    { lang: "fo-Faroese", langName: "fo-Faroese" },
    { lang: "fj-Fijian", langName: "fj-Fijian" },
    { lang: "fi-Finnish", langName: "fi-Finnish" },
    { lang: "fr-French", langName: "fr-French" },
    {
      lang: "ff-Fula, Fulah, Pulaar, Pular",
      langName: "ff-Fula, Fulah, Pulaar, Pular",
    },
    { lang: "gl-Galician", langName: "gl-Galician" },
    { lang: "gd-Gaelic (Scottish)", langName: "gd-Gaelic (Scottish)" },
    { lang: "gv-Gaelic (Manx)", langName: "gv-Gaelic (Manx)" },
    { lang: "ka-Georgian", langName: "ka-Georgian" },
    { lang: "de-German", langName: "de-German" },
    { lang: "el-Greek", langName: "el-Greek" },
    { lang: "kl-Greenlandic", langName: "kl-Greenlandic" },
    { lang: "gn-Guarani", langName: "gn-Guarani" },
    { lang: "gu-Gujarati", langName: "gu-Gujarati" },
    { lang: "ht-Haitian Creole", langName: "ht-Haitian Creole" },
    { lang: "ha-Hausa", langName: "ha-Hausa" },
    { lang: "he-Hebrew", langName: "he-Hebrew" },
    { lang: "hz-Herero", langName: "hz-Herero" },
    { lang: "hi-Hindi", langName: "hi-Hindi" },
    { lang: "ho-Hiri Motu", langName: "ho-Hiri Motu" },
    { lang: "hu-Hungarian", langName: "hu-Hungarian" },
    { lang: "is-Icelandic", langName: "is-Icelandic" },
    { lang: "io-Ido", langName: "io-Ido" },
    { lang: "ig-Igbo", langName: "ig-Igbo" },
    { lang: "in-Indonesian", langName: "in-Indonesian" },
    { lang: "id-Indonesian", langName: "id-Indonesian" },
    { lang: "ia-Interlingua", langName: "ia-Interlingua" },
    { lang: "ie-Interlingue", langName: "ie-Interlingue" },
    { lang: "iu-Inuktitut", langName: "iu-Inuktitut" },
    { lang: "ik-Inupiak", langName: "ik-Inupiak" },
    { lang: "ga-Irish", langName: "ga-Irish" },
    { lang: "it-Italian", langName: "it-Italian" },
    { lang: "ja-Japanese", langName: "ja-Japanese" },
    { lang: "jv-Javanese", langName: "jv-Javanese" },
    {
      lang: "kl-Kalaallisut, Greenlandic",
      langName: "kl-Kalaallisut, Greenlandic",
    },
    { lang: "kn-Kannada", langName: "kn-Kannada" },
    { lang: "kr-Kanuri", langName: "kr-Kanuri" },
    { lang: "ks-Kashmiri", langName: "ks-Kashmiri" },
    { lang: "kk-Kazakh", langName: "kk-Kazakh" },
    { lang: "km-Khmer", langName: "km-Khmer" },
    { lang: "ki-Kikuyu", langName: "ki-Kikuyu" },
    { lang: "rw-Kinyarwanda (Rwanda)", langName: "rw-Kinyarwanda (Rwanda)" },
    { lang: "rn-Kirundi", langName: "rn-Kirundi" },
    { lang: "ky-Kyrgyz", langName: "ky-Kyrgyz" },
    { lang: "kv-Komi", langName: "kv-Komi" },
    { lang: "kg-Kongo", langName: "kg-Kongo" },
    { lang: "ko-Korean", langName: "ko-Korean" },
    { lang: "ku-Kurdish", langName: "ku-Kurdish" },
    { lang: "kj-Kwanyama", langName: "kj-Kwanyama" },
    { lang: "lo-Lao", langName: "lo-Lao" },
    { lang: "la-Latin", langName: "la-Latin" },
    { lang: "lv-Latvian (Lettish)", langName: "lv-Latvian (Lettish)" },
    {
      lang: "li-Limburgish ( Limburger)",
      langName: "li-Limburgish ( Limburger)",
    },
    { lang: "ln-Lingala", langName: "ln-Lingala" },
    { lang: "lt-Lithuanian", langName: "lt-Lithuanian" },
    { lang: "lu-Luga-Katanga", langName: "lu-Luga-Katanga" },
    { lang: "lg-Luganda, Ganda", langName: "lg-Luganda, Ganda" },
    { lang: "lb-Luxembourgish", langName: "lb-Luxembourgish" },
    { lang: "gv-Manx", langName: "gv-Manx" },
    { lang: "mk-Macedonian", langName: "mk-Macedonian" },
    { lang: "mg-Malagasy", langName: "mg-Malagasy" },
    { lang: "ms-Malay", langName: "ms-Malay" },
    { lang: "ml-Malayalam", langName: "ml-Malayalam" },
    { lang: "mt-Maltese", langName: "mt-Maltese" },
    { lang: "mi-Maori", langName: "mi-Maori" },
    { lang: "mr-Marathi", langName: "mr-Marathi" },
    { lang: "mh-Marshallese", langName: "mh-Marshallese" },
    { lang: "mo-Moldavian", langName: "mo-Moldavian" },
    { lang: "mn-Mongolian", langName: "mn-Mongolian" },
    { lang: "na-Nauru", langName: "na-Nauru" },
    { lang: "nv-Navajo", langName: "nv-Navajo" },
    { lang: "ng-Ndonga", langName: "ng-Ndonga" },
    { lang: "nd-Northern Ndebele", langName: "nd-Northern Ndebele" },
    { lang: "ne-Nepali", langName: "ne-Nepali" },
    { lang: "no-Norwegian", langName: "no-Norwegian" },
    { lang: "nb-Norwegian bokmål", langName: "nb-Norwegian bokmål" },
    { lang: "nn-Norwegian nynorsk", langName: "nn-Norwegian nynorsk" },
    { lang: "ii-Nuosu", langName: "ii-Nuosu" },
    { lang: "oc-Occitan", langName: "oc-Occitan" },
    { lang: "oj-Ojibwe", langName: "oj-Ojibwe" },
    {
      lang: "cu-Old Church Slavonic, Old Bulgarian",
      langName: "cu-Old Church Slavonic, Old Bulgarian",
    },
    { lang: "or-Oriya", langName: "or-Oriya" },
    { lang: "om-Oromo (Afaan Oromo)", langName: "om-Oromo (Afaan Oromo)" },
    { lang: "os-Ossetian", langName: "os-Ossetian" },
    { lang: "pi-Pāli", langName: "pi-Pāli" },
    { lang: "ps-Pashto, Pushto", langName: "ps-Pashto, Pushto" },
    { lang: "fa-Persian (Farsi)", langName: "fa-Persian (Farsi)" },
    { lang: "pl-Polish", langName: "pl-Polish" },
    { lang: "pt-Portuguese", langName: "pt-Portuguese" },
    { lang: "pa-Punjabi (Eastern)", langName: "pa-Punjabi (Eastern)" },
    { lang: "qu-Quechua", langName: "qu-Quechua" },
    { lang: "rm-Romansh", langName: "rm-Romansh" },
    { lang: "ro-Romanian", langName: "ro-Romanian" },
    { lang: "ru-Russian", langName: "ru-Russian" },
    { lang: "se-Sami", langName: "se-Sami" },
    { lang: "sm-Samoan", langName: "sm-Samoan" },
    { lang: "sg-Sango", langName: "sg-Sango" },
    { lang: "sa-Sanskrit", langName: "sa-Sanskrit" },
    { lang: "sr-Serbian", langName: "sr-Serbian" },
    { lang: "sh-Serbo-Croatian", langName: "sh-Serbo-Croatian" },
    { lang: "st-Sesotho", langName: "st-Sesotho" },
    { lang: "tn-Setswana", langName: "tn-Setswana" },
    { lang: "sn-Shona", langName: "sn-Shona" },
    { lang: "ii-Sichuan Yi", langName: "ii-Sichuan Yi" },
    { lang: "sd-Sindhi", langName: "sd-Sindhi" },
    { lang: "si-Sinhalese", langName: "si-Sinhalese" },
    { lang: "ss-Siswati", langName: "ss-Siswati" },
    { lang: "sk-Slovak", langName: "sk-Slovak" },
    { lang: "sl-Slovenian", langName: "sl-Slovenian" },
    { lang: "so-Somali", langName: "so-Somali" },
    { lang: "nr-Southern Ndebele", langName: "nr-Southern Ndebele" },
    { lang: "es-Spanish", langName: "es-Spanish" },
    { lang: "su-Sundanese", langName: "su-Sundanese" },
    { lang: "sw-Swahili (Kiswahili)", langName: "sw-Swahili (Kiswahili)" },
    { lang: "ss-Swati", langName: "ss-Swati" },
    { lang: "sv-Swedish", langName: "sv-Swedish" },
    { lang: "tl-Tagalog", langName: "tl-Tagalog" },
    { lang: "ty-Tahitian", langName: "ty-Tahitian" },
    { lang: "tg-Tajik", langName: "tg-Tajik" },
    { lang: "ta-Tamil", langName: "ta-Tamil" },
    { lang: "tt-Tatar", langName: "tt-Tatar" },
    { lang: "te-Telugu", langName: "te-Telugu" },
    { lang: "th-Thai", langName: "th-Thai" },
    { lang: "bo-Tibetan", langName: "bo-Tibetan" },
    { lang: "ti-Tigrinya", langName: "ti-Tigrinya" },
    { lang: "to-Tonga", langName: "to-Tonga" },
    { lang: "ts-Tsonga", langName: "ts-Tsonga" },
    { lang: "tr-Turkish", langName: "tr-Turkish" },
    { lang: "tk-Turkmen", langName: "tk-Turkmen" },
    { lang: "tw-Twi", langName: "tw-Twi" },
    { lang: "ug-Uyghur", langName: "ug-Uyghur" },
    { lang: "uk-Ukrainian", langName: "uk-Ukrainian" },
    { lang: "ur-Urdu", langName: "ur-Urdu" },
    { lang: "uz-Uzbek", langName: "uz-Uzbek" },
    { lang: "ve-Venda", langName: "ve-Venda" },
    { lang: "vi-Vietnamese", langName: "vi-Vietnamese" },
    { lang: "vo-Volapük", langName: "vo-Volapük" },
    { lang: "wa-Wallon", langName: "wa-Wallon" },
    { lang: "cy-Welsh", langName: "cy-Welsh" },
    { lang: "wo-Wolof", langName: "wo-Wolof" },
    { lang: "fy-Western Frisian", langName: "fy-Western Frisian" },
    { lang: "xh-Xhosa", langName: "xh-Xhosa" },
    { lang: "yi-Yiddish", langName: "yi-Yiddish" },
    { lang: "yo-Yoruba", langName: "yo-Yoruba" },
    { lang: "za-Zhuang, Chuang", langName: "za-Zhuang, Chuang" },
    { lang: "zu-Zulu", langName: "zu-Zulu" },
  ];

  const [addForm, setAddForm] = React.useState<{ from: string; to: string }>({
    from: "",
    to: "",
  });
  const [redirects, setRedirects] = React.useState<
    { from: string; to: string; error?: string }[]
  >(props.redirects ?? []);

  React.useEffect(() => {
    setRedirects(props.redirects);
  }, [props.redirects]);

  const onAddRedirect = () => {
    // console.log('onAddRedirect', addForm);
    const from = addForm.from;
    const to = addForm.to;
    if (redirects.find((r) => r.from === from)) {
      return enqueueSnackbar("Redirect already exists", {
        variant: "error",
      });
    }

    if (from === to) {
      return enqueueSnackbar("Redirect From and To can't be same", {
        variant: "error",
      });
    }

    const redirectsCopy = JSON.parse(JSON.stringify(redirects));
    redirectsCopy.push({ from, to });
    setRedirects(redirectsCopy);
    setAddForm({ from: "", to: "" });
    props.onDataChange({ redirects: redirectsCopy });
  };

  const onChangeRedirect = (idx, value, field) => {
    const redirectsCopy = JSON.parse(JSON.stringify(redirects));
    redirectsCopy[idx][field] = value;
    setRedirects(redirectsCopy);

    // setting error if same value for redirect from
    validateErrors(redirectsCopy);

    props.onDataChange({ redirects: redirectsCopy });
  };

  const validateErrors = (redirectsCopy: any) => {
    const redirectsFrom = {};
    redirectsCopy.forEach((r) => {
      if (!redirectsFrom[r.from]) {
        redirectsFrom[r.from] = 0;
      }
      redirectsFrom[r.from]++;
    });

    redirectsCopy.forEach((r) => {
      if (redirectsFrom[r.from] > 1) {
        r.error = "duplicate";
      } else if (r.from === r.to) {
        r.error = "same";
      } else {
        delete r.error;
      }
    });

    redirectsCopy.filter((r) => r.error).length > 0
      ? props.setSaveDisabled(true)
      : props.setSaveDisabled(false);
  };

  const onRemoveRedirect = (idx) => {
    const redirectsCopy = JSON.parse(JSON.stringify(redirects));
    redirectsCopy.splice(idx, 1);
    setRedirects(redirectsCopy);
    validateErrors(redirectsCopy);
    props.onDataChange({ redirects: redirectsCopy });
  };

  return (
    <div className="flex flex-col text-black left-sidebar-seo">
      <div className="flex flex-col">
        <span className="text-base-2 mb-2">Primary language</span>
        <span className="font-normal mb-2">
          This language will be the default language of your website.
        </span>
        <div className="flex flex-row">
          <FormControl sx={{ maxWidth: "100%", width: "100%" }} size="small">
            <Select
              id="language-select"
              value={props.primaryLanguage}
              onChange={(e) => {
                // setSelectedLang(e.target.value)
                // console.log(e.target.value);
                props.onDataChange({ primaryLanguage: e.target.value });
              }}
              className="w-full md:w-[25rem] text-sm lang-selector"
            >
              {languages.map((row) => {
                return (
                  <MenuItem
                    key={row.lang}
                    className="text-sm site-lang"
                    value={row.lang}
                  >
                    {row.langName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
      </div>

      <div className="py-8">
        <Divider />
      </div>

      <div className="flex flex-col">
        <span className="text-base-2 mb-2">301 Redirects (URL mapping)</span>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse font-body rounded bg-white mb-2">
            <thead>
              <tr>
                <th className="text-left w-2/5 min-w-[200px] px-2 py-1 border text-base">
                  Redirect From
                </th>
                <th className="text-left w-2/5 min-w-[200px] px-2 py-1 border text-base">
                  Redirect To
                </th>
                <th className="text-center w-1/5 min-w-[150px] px-2 py-1 border text-base">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-left px-2 py-1 border text-xsm">
                  <Input
                    value={addForm.from}
                    className="w-full border rounded border-catelina-blue/60 py-1 px-2 text-base"
                    placeholder="abc"
                    onChange={(e) =>
                      setAddForm({ ...addForm, from: SanitizeTextboxInput(e.target.value) })
                    }
                    startAdornment="/"
                    size="small"
                    disableUnderline
                  />
                </td>
                <td className="text-left px-2 py-1 border text-xsm">
                  <Input
                    value={addForm.to}
                    className="w-full border rounded border-catelina-blue/60 py-1 px-2 text-base"
                    placeholder="xyz"
                    onChange={(e) =>
                      setAddForm({ ...addForm, to: SanitizeTextboxInput(e.target.value) })
                    }
                    startAdornment="/"
                    size="small"
                    disableUnderline
                  />
                </td>
                <td>
                  <Button
                    id="add"
                    className="w-11/12 py-1"
                    sx={{
                      textTransform: "none",
                    }}
                    variant="contained"
                    onClick={(e) => onAddRedirect()}
                  >
                    Add
                  </Button>
                </td>
              </tr>
              {redirects.map((row: any, idx: number) => {
                return (
                  <tr key={idx}>
                    <td className="text-left px-2 py-1 border text-xsm">
                      <Input
                        value={row.from}
                        className={`w-full border rounded border-catelina-blue/60 py-1 px-2 text-base ${
                          !!redirects[idx].error ? "border-red-600" : ""
                        }`}
                        onChange={(e) =>
                          onChangeRedirect(idx, e.target.value, "from")
                        }
                        startAdornment="/"
                        size="small"
                        disableUnderline
                        error={true}
                      />
                    </td>
                    <td className="text-left px-2 py-1 border text-xsm">
                      <Input
                        value={row.to}
                        className={`w-full border rounded border-catelina-blue/60 py-1 px-2 text-base ${
                          redirects[idx].error === "same"
                            ? "border-red-600"
                            : ""
                        }`}
                        onChange={(e) =>
                          onChangeRedirect(idx, e.target.value, "to")
                        }
                        startAdornment="/"
                        size="small"
                        disableUnderline
                      />
                    </td>
                    <td>
                      <Button
                        id="delete"
                        color="error"
                        className="w-11/12 py-1"
                        sx={{
                          textTransform: "none",
                        }}
                        variant="outlined"
                        onClick={(e) => onRemoveRedirect(idx)}
                      >
                        Remove
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {redirects.filter((r) => r.error === "duplicate").length > 0 && (
            <p className="font-normal mb-2 text-red-600">
              Please remove DUPLICATE redirects.
            </p>
          )}
          {redirects.filter((r) => r.error === "same").length > 0 && (
            <p className="font-normal mb-2 text-red-600">
              Redirect FROM and TO can't be same.
            </p>
          )}
        </div>
      </div>

      <div className="py-8">
        <Divider />
      </div>

      <div className="flex flex-col">
        <span className="text-base-2 mb-2">The sitemap.xml file URL</span>
        <span className="font-normal mb-2">
          The file is used by search engines. The file is auto-generated by
          RocketPages. We also auto-update when you create and publish a new
          page, delete or edit a page.
        </span>
        <div className="flex flex-row">
          <input
            disabled
            className="w-full md:w-[20rem] border rounded border-catelina-blue/60 py-1 px-2"
            // placeholder="<script src=”https;//www.googletagmanager.com/gtag/js?id=UA-XXX-X”></script>"
            value={"sitemap.xml"}
          />
        </div>
      </div>

      <div className="py-8">
        <Divider />
      </div>

      <div className="flex flex-col">
        <span className="text-base-2 mb-2">The robots.txt file URL:</span>
        <span className="font-normal mb-2">
          The file is used by search engines. The file is autogenerated by
          RocketPages and you can not change it
        </span>
        <div className="flex flex-row">
          <input
            disabled
            className="w-full md:w-[20rem] border rounded border-catelina-blue/60 py-1 px-2"
            // placeholder="<script src=”https;//www.googletagmanager.com/gtag/js?id=UA-XXX-X”></script>"
            value={"robots.txt"}
          />
        </div>
      </div>
    </div>
  );
};

export default ConfigSEO;
